
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attorneys/copp",
      function () {
        return require("private-next-pages/attorneys/copp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attorneys/copp"])
      });
    }
  